export default __webpack_public_path__ + "static/media/receipt-icon.d1c93dcc.svg";